import React from "react";
import { resilientSoftwareData } from "../data/software-apps";
import ResilentSoftwareArchitechture from "../icons/resilent-software-architechture";

const SoftwareArchitecture = () => {
  return (
    <div
      className="row align-items-center"
      id="resilient-software-architecture"
    >
      <div className="col-12 col-lg-6 order-2 order-md-1">
        <div className="row">
          <div className="col-12 col-md-6">
            {resilientSoftwareData.slice(0, 2).map((info, index) => (
              <div
                key={index}
                className="text-center digital-card border px-4 py-5 my-4 rounded"
              >
                <img
                  src={info.img}
                  loading="lazy"
                  alt={info.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{info.title}</h3>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-6 mt-0 mt-md-5">
            {resilientSoftwareData.slice(2, 4).map((info) => (
              <div
                key={info.title}
                className="text-center digital-card border px-4 py-5 mb-4 rounded"
              >
                <img
                  src={info.img}
                  loading="lazy"
                  alt={info.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{info.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-6 text-center text-lg-end order-1 order-md-2">
        <ResilentSoftwareArchitechture />
        <h2 className="fs-56 lh-64 text-danger gilroy-bold py-5">
          Resilient Software Architecture
        </h2>
        <p className="fs-16 text-align-justify">
          You'll be able construct a reliable and energetic item center. and
          dodge over-engineered arrangements that severely influence your
          commerce results. Tell us your breakthroughs, and we’ll tell you which
          program frameworks and arrangement stacks offer you tall
          accessibility, adaptability, and security that beats an on-premise
          setup. Scaling up? Work in match with modelers who created a ticketing
          benefit or a nonbank that benefit millions of clients.
        </p>
      </div>
    </div>
  );
};

export default SoftwareArchitecture;
